import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";

import { CrossSellingProduct } from "@hermes/api-model-product";
import {
    LazyLoadedProduct,
    ProductContentImpressionEvent,
} from "@hermes/states/product-page";
import { AnalyticsService } from "@hermes/utils/analytics";
import { skuToId } from "@hermes/utils-generic/helpers";

export type GridTitle = "keep_exploring" | "perfect_partner";

@Component({
    selector: "h-product-page-grid",
    templateUrl: "./product-page-grid.component.html",
    styleUrls: ["./product-page-grid.component.scss"],
})
export class ProductPageGridComponent implements OnInit, OnDestroy {
    @Input()
    public crossSellingProducts!: CrossSellingProduct[];

    @Input()
    public gridTitle!: GridTitle;

    /**
     * Array of product displayed on user screen ordered by index on grid
     */
    public productsLazyLoaded: CrossSellingProduct[] = [];

    /**
     * Used to debounce impression event, we must send an array of product displayed
     * Without this we send an event for each product
     */
    public printEvents: Subject<void> = new Subject<void>();
    private subscription: Subscription = new Subscription();

    constructor(private analyticsService: AnalyticsService) {}

    public ngOnInit(): void {
        this.subscription.add(
            this.printEvents.pipe(debounceTime(1000)).subscribe(() => {
                this.productsLazyLoaded =
                    this.productsLazyLoaded.filter(Boolean);
                this.analyticsService.sendData(
                    new ProductContentImpressionEvent({
                        products: this.productsLazyLoaded,
                        list: this.gridTitle,
                    }),
                );
                this.productsLazyLoaded = [];
            }),
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    /**
     * Store products displayed in an array ordered by index in grid
     *
     * @param event contained index of product on grid and product data
     */
    public sendLazyLoadImpressionEvent(event: LazyLoadedProduct): void {
        this.productsLazyLoaded[event.index] = event.product;
        this.printEvents.next();
    }

    /**
     * Track products by sku so that angular does not refresh the array if products does not change.
     */
    public trackBySku(_index: number, item: CrossSellingProduct): string {
        return skuToId(item.sku);
    }
}
